import React from 'react';
import { useAuth, VIEW_MODES } from '../context/AuthContext';
import DashboardSimple from './DashboardSimple';
import DashboardStandard from './DashboardStandard';
import DashboardDetailed from './DashboardDetailed';

const Dashboard = () => {
  const { viewMode } = useAuth();

  // Render the appropriate dashboard based on view mode
  switch (viewMode) {
    case VIEW_MODES.SIMPLE:
      return <DashboardSimple />;
    case VIEW_MODES.DETAILED:
      return <DashboardDetailed />;
    case VIEW_MODES.STANDARD:
    default:
      return <DashboardStandard />;
  }
};

export default Dashboard;
